import React, { useState } from 'react';
import ContactModal from './ContactModal';

const Services = () => {
  const [showForm, setShowForm] = useState(false);
  const services = [
    {
      image: "/images/card3.jpg",
      title: "Lawn Mowing"
    },
    {
      image: "/images/card4.jpg",
      title: "Leaf Blowing"
    },
    {
      image: "/images/card5.jpg",
      title: "Snow Management"
    }
  ];

  return (
    <section className="py-4 md:py-4">
      <h1 className="dest_heading">Our Magic Services</h1>
      <section className="product px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
          {services.map((service, index) => (
            <div key={index} className="col-span-1">
              <div className="product-image">
                <img src={service.image} className="product-thumb" alt={service.title} />
                <button 
                  onClick={() => setShowForm(true)}
                  className="card-btn"
                >
                  Contact Now
                </button>
              </div>
              <div className="product-info">
                <h2 className="product-brand">{service.title}</h2>
              </div>
            </div>
          ))}
        </div>
      </section>
      
      <div className="flex justify-center my-8 max-sm:pb-6">
        <button 
          onClick={() => setShowForm(true)}
          className="btn-primary text-white border-0 py-3 px-8 focus:outline-none rounded-lg text-lg font-semibold"
        >
          Contact Now
        </button>
      </div>
      
      <ContactModal isOpen={showForm} onClose={() => setShowForm(false)} />
    </section>
  );
};

export default Services;